/* VALYA product card: the card behaviour of the home products section (heart and eye, BUY NOW, the second
   picture opening on hover, the colour change) for every "Design 1" product card on the store, including cards
   that arrive later (recommendations, quick view, load more). Cards inside a VALYA carousel are left to it. */(function () {
  if (window.vkCard) return; window.vkCard = true;
  var seen = window.WeakSet ? new WeakSet() : null;
  var run = function (cards) {
    var wrap = { querySelectorAll: function () { return cards; } };
    /* Colour swap without the grey flash. The theme keeps the same <img> but rewrites its data-srcset and flips its
       class from lazyloadt4sed (loaded) to lazyloadt4s (loading); its grey loader shows in that gap. So the picture
       wrapper is watched: the moment the image drops out of the loaded state, a copy of the picture that was on show
       is laid over it, and it stays until the image is loaded again with a different source, then wipes away. */
    Array.prototype.forEach.call(wrap.querySelectorAll('.t4s-product'), function (card) {
      var inner = card.querySelector('.t4s-product-inner');
      var img = inner && inner.querySelector('img.t4s-product-main-img, .t4s-product-img img, img');
      if (!img || !window.MutationObserver) return;
      var wrap = img.closest('.t4s-product-img') || img.parentElement;
      if (getComputedStyle(inner).position === 'static') inner.style.position = 'relative';
      var loaded = function (i) { return i.classList.contains('lazyloadt4sed') || (!i.classList.contains('lazyloadt4s') && !i.classList.contains('lazyloadt4sing')); };
      var shownSrc = function (i) { var u = i.currentSrc || ''; return (u && u.indexOf('data:') !== 0) ? u : ''; };
      var last = (img.complete && loaded(img)) ? shownSrc(img) : '', hold = null, timer = 0, pt = {};
      /* where the swatch was pressed, measured against the picture: the iris closes towards it */
      card.addEventListener('pointerdown', function (e) {
        var r = wrap.getBoundingClientRect();
        pt = { x: Math.round((e.clientX - r.left) / r.width * 100), y: Math.round((e.clientY - r.top) / r.height * 100) };
      }, { passive: true });
      var release = function () {
        if (!hold) return;
        var h = hold; hold = null; clearTimeout(timer);
        h.classList.add('is-out'); inner.classList.add('is-out');
        setTimeout(function () { if (h.parentNode) h.parentNode.removeChild(h); inner.classList.remove('vc-swapping', 'is-out'); }, 900);
      };
      var engage = function () {
        if (hold || !last) return;
        var r = wrap.getBoundingClientRect(), b = inner.getBoundingClientRect();
        hold = document.createElement('span');
        hold.className = 'vc-hold';
        hold.setAttribute('aria-hidden', 'true');
        hold.style.cssText = 'left:' + (r.left - b.left) + 'px;top:' + (r.top - b.top) + 'px;width:' + r.width + 'px;height:' + r.height + 'px;';
        var im = new Image(); im.alt = ''; im.src = last;
        hold.appendChild(im);
        inner.appendChild(hold);
        inner.classList.add('vc-swapping');
        timer = setTimeout(release, 4500);                    /* never hold the old picture for ever */
      };
      var check = function () {
        var i = wrap.querySelector('img:not(.vc-alt img):not(.vc-hold img)') || img;
        if (i !== img) { img = i; i.addEventListener('load', onLoad); }
        if (!loaded(i) || (!i.complete)) engage();           /* loading has begun: cover it */
        else if (hold) { var now = shownSrc(i); if (now && now !== last) { last = now; requestAnimationFrame(release); } }
        else { var s0 = shownSrc(i); if (s0) last = s0; }
      };
      var onLoad = function () { requestAnimationFrame(check); };
      img.addEventListener('load', onLoad);
      new MutationObserver(function () { requestAnimationFrame(check); })
        .observe(wrap, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'src', 'srcset', 'data-srcset', 'data-src'] });
    });
    /* BUY NOW under every card: a link to the product, or a press on the theme's own quick-shop button */
    Array.prototype.forEach.call(wrap.querySelectorAll('.t4s-product'), function (card) {
      var info = card.querySelector('.t4s-product-info__inner') || card.querySelector('.t4s-product-info');
      if (!info || info.querySelector('.vc-buy')) return;
      var link = card.querySelector('a[href*="/products/"]');
      var a = document.createElement('a'); a.className = 'vc-buy'; a.href = link ? link.href : '#'; a.innerHTML = '<span>Buy now</span>';
      info.appendChild(a);
      a.addEventListener('click', function (e) {
        var rc = a.getBoundingClientRect(), r = document.createElement('span'); r.className = 'vc-rp';
        r.style.left = (e.clientX - rc.left) + 'px'; r.style.top = (e.clientY - rc.top) + 'px'; a.appendChild(r);
        if (r.animate) r.animate([{ transform: 'scale(1)', opacity: 1 }, { transform: 'scale(28)', opacity: 0 }], { duration: 700, easing: 'cubic-bezier(.16,1,.3,1)' }).onfinish = function () { r.remove(); };
      });
    });
    /* Card buttons. The theme's own buttons stay in the page (hidden) with their own click code; ours press them.
       Quick shop, add to cart and compare are hidden and have no stand-in. */
    var EYE = '<svg viewBox="0 0 24 24"><path class="w" d="M1.5 12S5.5 4.5 12 4.5 22.5 12 22.5 12 18.5 19.5 12 19.5 1.5 12 1.5 12z"/><circle class="p" cx="12" cy="12" r="4.2"/><circle class="g" cx="13.6" cy="10.4" r="1.2"/></svg>';
    var HEART = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round"><path d="M12 20.5s-7.8-4.7-9.6-9.4C1 7.4 3.3 4 6.8 4c2.1 0 3.8 1.1 5.2 2.9C13.4 5.1 15.1 4 17.2 4c3.5 0 5.8 3.4 4.4 7.1-1.8 4.7-9.6 9.4-9.6 9.4z"/></svg>';
    var TINY = '<svg viewBox="0 0 24 24"><path d="M12 21s-7.5-4.6-9.6-9.2C.9 8.4 3 4.6 6.6 4.6c2 0 3.6 1 4.4 2.5.8-1.5 2.4-2.5 4.4-2.5 3.6 0 5.7 3.8 4.2 7.2C19.5 16.4 12 21 12 21z"/></svg>';
    /* the burst: drawn live on a canvas over the picture (thousands of points if need be, on the GPU-backed canvas),
       one of three choreographies chosen in the settings; only that one is printed */
    var HP = 'M12 20.5s-7.8-4.7-9.6-9.4C1 7.4 3.3 4 6.8 4c2.1 0 3.8 1.1 5.2 2.9C13.4 5.1 15.1 4 17.2 4c3.5 0 5.8 3.4 4.4 7.1-1.8 4.7-9.6 9.4-9.6 9.4z';
    var heartPath = window.Path2D ? new Path2D(HP) : null;
    var R = function (a, b) { return a + Math.random() * (b - a); };
    var drawHeart = function (ctx, x, y, sz, rot, col, alpha, sx) {
      if (!heartPath) return;
      ctx.save(); ctx.translate(x, y); ctx.rotate(rot || 0); ctx.scale((sx == null ? 1 : sx) * sz / 24, sz / 24); ctx.translate(-12, -12);
      ctx.globalAlpha = alpha; ctx.fillStyle = col; ctx.fill(heartPath); ctx.restore();
    };
    var EFFECT = {
      /* glitter 3D: solid hearts spin in three dimensions, catch the light on their edges, and bounce on the floor */
      init: function (o, box) { var P = []; for (var i = 0; i < 44; i++) { var a = R(-2.9, .4), sp = R(120, 300); P.push({ x: o.x, y: o.y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, s: R(8, 18), ry: R(0, 6), rs: R(3, 9), rz: R(-2, 2), c: ['#E8455C', '#FF3B5C', '#C8102E', '#FF8FA6'][i % 4], l: R(2, 2.8), d: i * .012 }); } return { P: P, floor: box.h - 10 }; },
      frame: function (ctx, S, t, dt) {
        var alive = false;
        S.P.forEach(function (p) {
          if (t < p.d) return;
          p.vy += 520 * dt; p.vx *= .995; p.x += p.vx * dt; p.y += p.vy * dt; if (p.y > S.floor) { p.y = S.floor; p.vy = -p.vy * .5; p.vx *= .8; } p.l -= dt; if (p.l <= 0) return; alive = true;
          var f = Math.cos(t * p.rs + p.ry), a = Math.min(1, p.l) * Math.min(1, (t - p.d) * 5);
          ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(t * p.rz); ctx.globalAlpha = a; ctx.shadowBlur = 4; ctx.shadowColor = 'rgba(0,0,0,.3)'; ctx.shadowOffsetY = 2;
          drawHeart(ctx, 0, 0, p.s, 0, f > 0 ? p.c : '#8a0f22', 1, Math.max(.08, Math.abs(f)));
          if (Math.abs(f) < .35) { ctx.globalCompositeOperation = 'lighter'; drawHeart(ctx, 0, 0, p.s, 0, '#fff', (.35 - Math.abs(f)) * 2.2, Math.max(.08, Math.abs(f))); }
          ctx.restore(); ctx.globalCompositeOperation = 'source-over';
        });
        return alive;
      }
    };
    var burst = function (btn) {
      var inner = btn.closest('.t4s-product-inner');
      if (!inner || !heartPath) return;
      var old = inner.querySelector('.vcb-canvas'); if (old) old.remove();
      var cv = document.createElement('canvas'); cv.className = 'vcb-canvas';
      var w = inner.clientWidth, h = inner.clientHeight, dpr = Math.min(2, window.devicePixelRatio || 1);
      cv.width = w * dpr; cv.height = h * dpr; inner.appendChild(cv);
      var ctx = cv.getContext('2d'); ctx.scale(dpr, dpr);
      var r = btn.getBoundingClientRect(), b = inner.getBoundingClientRect();
      var o = { x: r.left - b.left + r.width / 2, y: r.top - b.top + r.height / 2 };
      var S = EFFECT.init(o, { w: w, h: h }), t0 = performance.now(), last = t0;
      var loop = function (now) {
        var dt = Math.min(.033, (now - last) / 1000); last = now;
        ctx.clearRect(0, 0, w, h);
        var alive = EFFECT.frame(ctx, S, (now - t0) / 1000, dt);
        if (alive && now - t0 < 5000) requestAnimationFrame(loop); else cv.remove();
      };
      requestAnimationFrame(loop);
    };
    /* what a button is: its words, its classes, its data-* names, its title / tooltip; never its link */
    var kind = function (el) {
      var attrs = Array.prototype.map.call(el.attributes, function (a) {
        return /^(class|title|aria-label|data-tooltip|data-tip|data-title)$/.test(a.name) ? a.name + '=' + a.value : (/^data-/.test(a.name) ? a.name : '');
      }).join(' ');
      var hay = ((el.textContent || '') + ' ' + attrs).toLowerCase();
      if (/compare/.test(hay)) return 'compare';
      if (/quick.?view/.test(hay)) return 'view';
      if (/wish|heart|fave/.test(hay)) return 'wish';
      if (/quick.?shop|add.?to.?cart|addtocart|-atc|atc-|\bcart\b/.test(hay)) return 'cart';
      return '';
    };
    /* the theme's (or an app's) own button of a kind, found when it is needed, even if it was added after the page loaded */
    var find = function (card, k) {
      var direct = card.querySelector(k === 'wish' ? '[data-action-wishlist]' : k === 'view' ? '[data-action-quickview]' : '.vc-none');
      if (direct) return direct;
      var all = card.querySelectorAll('a, button');
      for (var i = 0; i < all.length; i++) {
        var el = all[i];
        if (el.closest('.vcb-box, .t4s-product-info') || el.querySelector('img')) continue;
        if (kind(el) === k) return el;
      }
      return null;
    };
    /* press: the theme's quick-view needs the button's link (it reads the product from it), so the link stays and the
       theme's own handler stops the page from opening; the wishlist button loses its link for the instant of the press,
       because when the product is already on the list that link leads to the wishlist page */
    var press = function (el, keepHref) {
      if (!el) return false;
      var st = (el.className + ' ' + (el.getAttribute('data-tooltip') || '') + ' ' + (el.getAttribute('title') || '') + ' ' + (el.textContent || '')).toLowerCase();
      if (!keepHref && (/is--added|\badded\b|browse|in-wishlist/.test(st) || el.getAttribute('aria-pressed') === 'true')) return true;
      var href = el.getAttribute('href');
      if (href && !keepHref) el.removeAttribute('href');
      var ev = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
      el.dispatchEvent(ev);
      if (href && !keepHref) setTimeout(function () { el.setAttribute('href', href); }, 50);
      return true;
    };
    var tagButtons = function (card) {
      var inner = card.querySelector('.t4s-product-inner');
      if (!inner || inner.querySelector('.vcb-box')) return;
      /* quick shop / add to cart: hidden by name as well (the CSS covers the rest) */
      var hideCart = function () {
        Array.prototype.forEach.call(inner.querySelectorAll('a, button'), function (el) { if (!el.classList.contains('vc-hide') && !el.closest('.vcb-box') && !el.querySelector('img') && kind(el) === 'cart') el.classList.add('vc-hide'); });
        Array.prototype.forEach.call(inner.querySelectorAll('[class*="btns"], [class*="btn-group"]'), function (g) {
          if (g.closest('.vcb-box') || g.classList.contains('vc-hide')) return;
          var left = Array.prototype.filter.call(g.querySelectorAll('a, button'), function (b) { return !b.classList.contains('vc-hide') && getComputedStyle(b).display !== 'none'; });
          if (!left.length) g.classList.add('vc-hide');
        });
      };
      hideCart();
      var box = document.createElement('div'); box.className = 'vcb-box';
      var h = document.createElement('button'); h.type = 'button'; h.className = 'vcb vcb-h'; h.setAttribute('aria-label', 'Add to wishlist'); h.innerHTML = HEART;
      var e = document.createElement('button'); e.type = 'button'; e.className = 'vcb vcb-e'; e.setAttribute('aria-label', 'Quick view'); e.innerHTML = EYE;
      box.appendChild(h); box.appendChild(e); inner.appendChild(box);
      var link = card.querySelector('a[href*="/products/"]');
      e.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); if (!press(find(card, 'view'), true) && link) location.href = link.href; });
      /* the heart tells the truth: red when the product is on the wishlist. On load that is read from the theme's own
         button (Kalles marks it is--added) and from the wishlist the theme keeps in the browser; after that the theme's
         button is watched, so the heart follows it whichever way the product goes on or off the list */
      var pid = card.getAttribute('data-id') || (find(card, 'wish') && find(card, 'wish').getAttribute('data-id')) || '';
      var handle = (link && link.pathname.replace(/^.*\/products\/([^/?#]+).*$/, '$1')) || '';
      var stored = function () {
        try {
          for (var i = 0; i < localStorage.length; i++) {
            var k = localStorage.key(i);
            if (!/wish/i.test(k)) continue;
            var v = localStorage.getItem(k) || '';
            if ((pid && v.indexOf(pid) > -1) || (handle && v.indexOf(handle) > -1)) return true;
          }
        } catch (err) {}
        return false;
      };
      var listed = function () {
        var th = find(card, 'wish');
        var st = th ? (th.className + ' ' + (th.getAttribute('data-tooltip') || '') + ' ' + (th.getAttribute('title') || '')).toLowerCase() : '';
        return /is--added|\badded\b|browse|in-wishlist/.test(st) || (th && th.getAttribute('aria-pressed') === 'true') || stored();
      };
      /* taking it off the list from the card: the theme cannot, so the theme's own saved list in the browser is edited
         (the entry that names this product is removed), the theme's button is set back to "add", and the header count drops */
      var unlist = function () {
        var done = false;
        try {
          for (var i = 0; i < localStorage.length; i++) {
            var k = localStorage.key(i);
            if (!/wish/i.test(k)) continue;
            var raw = localStorage.getItem(k) || '';
            if (!((pid && raw.indexOf(pid) > -1) || (handle && raw.indexOf(handle) > -1))) continue;
            var val; try { val = JSON.parse(raw); } catch (e) { val = null; }
            var hit = function (x) { var t = String(typeof x === 'object' && x ? JSON.stringify(x) : x); return (pid && t.indexOf(pid) > -1) || (handle && t.indexOf(handle) > -1); };
            if (Array.isArray(val)) { val = val.filter(function (x) { return !hit(x); }); localStorage.setItem(k, JSON.stringify(val)); done = true; }
            else if (val && typeof val === 'object') { Object.keys(val).forEach(function (kk) { if (hit(kk) || hit(val[kk])) delete val[kk]; }); localStorage.setItem(k, JSON.stringify(val)); done = true; }
            else if (typeof raw === 'string') {
              var parts = raw.split(/[,\s]+/).filter(function (x) { return x && !hit(x); });
              localStorage.setItem(k, parts.join(',')); done = true;
            }
          }
        } catch (err) {}
        var th = find(card, 'wish');
        if (th) { th.classList.remove('is--added'); th.removeAttribute('aria-pressed'); }
        /* the number in the header's heart */
        Array.prototype.forEach.call(document.querySelectorAll('.t4s-site-nav__heart *'), function (el) {
          if (el.children.length === 0 && /^\s*\d+\s*$/.test(el.textContent)) { var nn = Math.max(0, parseInt(el.textContent, 10) - 1); el.textContent = String(nn); }
        });
        return done;
      };
      var pressedAt = 0;
      var reflect = function () {
        if (Date.now() - pressedAt < 2500) return;              /* just pressed: the burst and the red stay */
        var on = listed();
        if (h.classList.contains('is-on') !== on) h.classList.toggle('is-on', on);
      };
      reflect();
      setTimeout(reflect, 800); setTimeout(reflect, 2500);       /* the theme fills its list a moment after the page is up */
      var th0 = find(card, 'wish');
      if (th0 && window.MutationObserver) new MutationObserver(function () { setTimeout(reflect, 50); }).observe(th0, { attributes: true, attributeFilter: ['class', 'aria-pressed', 'data-tooltip'] });
      h.addEventListener('click', function (ev) {
        ev.preventDefault(); ev.stopPropagation();
        var on = !h.classList.contains('is-on');
        pressedAt = Date.now();
        h.classList.toggle('is-on', on);
        if (h.animate) h.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.3)' }, { transform: 'scale(1)' }], { duration: 450, easing: 'cubic-bezier(.34,1.56,.64,1)' });
        if (on) { burst(h); press(find(card, 'wish')); }
        else unlist();
      });
      if (window.MutationObserver) {
        var queued = false, mo;
        var run = function () { queued = false; mo.disconnect(); hideCart(); watch(); };
        var watch = function () { mo.observe(inner, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-pressed', 'data-tooltip', 'class'] }); };
        mo = new MutationObserver(function (list) {
          for (var i = 0; i < list.length; i++) {
            var t = list[i].target;
            if (t.closest && t.closest('.vcb-box')) continue;                 /* our own pair: never a reason to run */
            if (list[i].type === 'attributes' && t.classList && t.classList.contains('vc-hide')) continue;
            if (!queued) { queued = true; requestAnimationFrame(run); }
            return;
          }
        });
        watch();
      }
    };
    Array.prototype.forEach.call(wrap.querySelectorAll('.t4s-product'), tagButtons);

    /* Second picture: opened on hover as a circle from the point where the mouse came in.
       It puts itself back whenever the theme rebuilds a card's picture (a colour swatch, a quick view,
       the theme's own card script running late), so the theme's hover never takes over again.
       If the theme adds a second picture of its own, that one is hidden and this one stays. */
    if (!window.matchMedia || !matchMedia('(hover: hover)').matches) return;
    var OURS = '.vc-alt, .vc-ring, .vc-hold, .vcb-box, .vcb-canvas';
    var place = function (card) {
      var link = card.querySelector('a[href*="/products/"]');
      var inner = card.querySelector('.t4s-product-inner');
      if (!link || !inner) return;
      var src = card.getAttribute('data-vk-alt');
      if (!src) return;
      var img = null, imgs = inner.querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) { if (!imgs[i].closest(OURS)) { img = imgs[i]; break; } }
      if (!img) return;
      var box = img.parentElement;
      Array.prototype.forEach.call(box.children, function (o) {
        if (o.tagName === 'IMG' && o !== img && o.style.getPropertyValue('display') !== 'none') o.style.setProperty('display', 'none', 'important');
      });
      if (box.querySelector(':scope > .vc-alt')) { if (!box.classList.contains('vc-has-alt')) box.classList.add('vc-has-alt'); return; }
      if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
      var alt = document.createElement('span');
      alt.className = 'vc-alt';
      alt.setAttribute('aria-hidden', 'true');
      var im = new Image();
      im.alt = ''; im.loading = 'lazy'; im.decoding = 'async'; im.src = src;
      alt.appendChild(im);
      var ring = document.createElement('span');
      ring.className = 'vc-ring';
      ring.setAttribute('aria-hidden', 'true');
      box.appendChild(alt);
      box.appendChild(ring);
      box.classList.add('vc-has-alt');
      if (!inner.vcHover) {
        inner.vcHover = true;
        inner.addEventListener('pointerenter', function (e) {
          var a = inner.querySelector('.vc-alt'), rg = inner.querySelector('.vc-ring');
          if (!a) return;
          var r = a.parentElement.getBoundingClientRect();
          var mx = Math.round((e.clientX - r.left) / r.width * 100) + '%', my = Math.round((e.clientY - r.top) / r.height * 100) + '%';
          a.style.setProperty('--mx', mx); a.style.setProperty('--my', my);
          if (rg) { rg.style.setProperty('--mx', mx); rg.style.setProperty('--my', my); }
        });
      }
    };
    var vcCards = Array.prototype.slice.call(wrap.querySelectorAll('.t4s-product'));
    vcCards.forEach(function (card) {
      place(card);
      var inner = card.querySelector('.t4s-product-inner');
      if (!inner || !window.MutationObserver) return;
      var queued = false;
      new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          var t = list[i].target;
          if (t.closest && t.closest(OURS)) continue;
          if (!queued) { queued = true; requestAnimationFrame(function () { queued = false; place(card); }); }
          return;
        }
      }).observe(inner, { childList: true, subtree: true });
    });
    addEventListener('pageshow', function () { vcCards.forEach(place); });
  };
  var pending = [], queued = false;
  var take = function (c) {
    if (c.closest('.vc-track') || (seen && seen.has(c)) || c.vkSeen) return;
    if (seen) seen.add(c); else c.vkSeen = true;
    pending.push(c);
  };
  var flush = function () { queued = false; var list = pending; pending = []; if (list.length) run(list); };
  var scan = function (root) {
    if (root.nodeType !== 1) return;
    if (root.classList.contains('vk-card')) take(root);
    Array.prototype.forEach.call(root.querySelectorAll('.vk-card'), take);
    if (pending.length && !queued) { queued = true; requestAnimationFrame(flush); }
  };
  var start = function () {
    scan(document.documentElement);
    if (window.MutationObserver) new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) for (var j = 0; j < list[i].addedNodes.length; j++) scan(list[i].addedNodes[j]);
    }).observe(document.documentElement, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();